// extracted by mini-css-extract-plugin
export var baseButton = "_p4-0";
export var controlsArrowKeys = "_p4-1";
export var controlsResetButton = "_p4-2";
export var lightGameButton = "_p4-4 _p4-0";
export var playAgainButton = "_p4-5 _p4-0";
export var startGameButton = "_p4-3 _p4-0";